import React, {useContext, useEffect, useState} from "react";
import {App, Button, Checkbox, Descriptions, Form, Input, InputNumber, Radio, Space, Timeline, Typography} from "antd";
import _ from "lodash";
import dayjs from 'dayjs'
import {FaCheck} from "react-icons/fa"
import {TiArrowSortedDown, TiArrowSortedUp} from "react-icons/ti"
import {API, Enum} from "../../resources/constants";
import language from "../../resources/languages/fa_IR";

// Interfaces
import {AxiosError} from "../../interfaces/axios"

// Contexts
import GlobalContext from '../../contexts/global';
import AxiosContext from "../../contexts/axios";

const currency = new Intl.NumberFormat()
const { Components: { Booking }, Validation, Enum: EnumLanguage, Message: MessageLanguage } = language
const { Message, TravelType, Payment } = Enum
const { TRAVEL_PAYMENT_ZARINPAL_REQUEST, TRAVEL_PAYMENT_SEP_REQUEST, TRAVEL_PAYMENT_PEP_REQUEST } = API

export default function Index() {

    const [form] = Form.useForm()
    const [, forceUpdate] = useState({})
    const { travel, travelType: travelTypeGlobal, user, dispatch } = useContext(GlobalContext)
    const [travelType, settTravelType] = useState<string>(travelTypeGlobal)
    const [person, setPerson] = useState<boolean>(travelTypeGlobal === TravelType.Person)
    const [close, setClose] = useState<boolean>(travelTypeGlobal === TravelType.Close)
    const [personCount, setPersonCount] = useState<number>(1)
    const [policy, setPolicy] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const { axios } = useContext(AxiosContext)
    const { message } = App.useApp()

    // To disable submit button at the beginning.
    useEffect(() => {
        forceUpdate({})
    }, []);

    const plusPersonCount = (capacity: number) => {
        const count = personCount >= capacity ? capacity : personCount + 1
        form.setFieldValue('personCount', count)
        setPersonCount(count)
    }

    const minusPersonCount = () => {
        const count = personCount <= 1 ? 1 : personCount - 1
        form.setFieldValue('personCount', count)
        setPersonCount(count)
    }

    const onFinish = (values: { payment?: string }) => {
        setLoading(true);
        const { payment } = values
        switch (payment) {
            case Payment.Zarinpal:
                axios.post(TRAVEL_PAYMENT_ZARINPAL_REQUEST, {...values}).then((response: { data: {} }) => {
                const { data: authority } = response;
                window.location.replace(`${process.env.REACT_APP_ZARINPAL_PAYMENT_START_PAY}${authority}`);
            }).catch( (error: AxiosError) => {
                setLoading(false);
                const { response: { data } } = error;
                // @ts-ignore
                message.error(MessageLanguage[data.message] || MessageLanguage.PAYMENT_INVALID).then(response => response)
            });
                break;

            case Payment.Sep:
                axios.post(TRAVEL_PAYMENT_SEP_REQUEST, {...values}).then((response: { data: {} }) => {
                    const { data: token } = response;
                    window.location.replace(`${process.env.REACT_APP_SEP_PAYMENT_START_PAY}?token=${token}`);
                }).catch( (error: AxiosError) => {
                    setLoading(false);
                    const { response: { data } } = error;
                    // @ts-ignore
                    message.error(MessageLanguage[data.message] || MessageLanguage.PAYMENT_INVALID).then(response => response)
                });
                break;

            case Payment.Pep:
                axios.post(TRAVEL_PAYMENT_PEP_REQUEST, {...values}).then((response: { data: {} }) => {
                    const { data: token } = response;
                    window.location.replace(`${process.env.REACT_APP_PEP_PAYMENT_START_PAY}${token}`);
                }).catch( (error: AxiosError) => {
                    setLoading(false);
                    const { response: { data } } = error;
                    // @ts-ignore
                    message.error(MessageLanguage[data.message] || MessageLanguage.PAYMENT_INVALID).then(response => response)
                });
                break;
        }
    };

    if (travel && !_.isEmpty(travel)) {
        // @ts-ignore
        const { id, origin, originLocation, destination, destinationLocation, date, car, seat, owner, number: code, travelType: travelBookingType, personPrice = 0, closePrice = 0, homePrice = 0, seatsLeft } = travel

        // @ts-ignore
        const { firstName, lastName } = user;

        const payments = owner ? Object.entries(owner).filter(([key, value]) => ['pep', 'sep', 'zarinpal'].includes(key) && value).map(([key, value]) => key.toUpperCase()): [];

        const capacity = seatsLeft === null ? seat : seatsLeft;
        const travelPrice = [
            {
                name: TravelType.Person,
                price: personPrice,
            },
            {
                name: TravelType.Close,
                price: closePrice,
            },
            {
                name: TravelType.Home,
                price: homePrice,
            },
        ].filter(({ name }) => name === travelType)
        const price: number = travelPrice.length ? (person ? personCount * (travelPrice[0].price/10) : travelPrice[0].price/10) : 0;

        return (
            <Space direction={'vertical'} style={{ width: '100%' }} size={'large'}>
                <Descriptions bordered size={'small'}>
                    <Descriptions.Item key={'code'} span={24} label={`${Booking.code}:`}>{code}</Descriptions.Item>
                    <Descriptions.Item key={'name'} span={24} label={`${Booking.name}:`}>{firstName} {lastName}</Descriptions.Item>
                    <Descriptions.Item key={'origin'} span={24} label={`${Booking.origin}:`}>{origin.name}</Descriptions.Item>
                    <Descriptions.Item key={'destination'} span={24} label={`${Booking.destination}:`}>{destination.name}</Descriptions.Item>
                    <Descriptions.Item key={'date'} span={24} label={`${Booking.date}:`}>{dayjs(date).format('YYYY/MM/DD')}</Descriptions.Item>
                    <Descriptions.Item key={'time'} span={24} label={`${Booking.time}:`}>{dayjs(date).format('HH:mm')}</Descriptions.Item>
                    {(person || close) && <Descriptions.Item key={'address'} span={24} label={`${Booking.address}:`}>{originLocation.address}</Descriptions.Item>}
                    <Descriptions.Item span={24} key={'car'} label={`${Booking.car}:`}>{car.name}</Descriptions.Item>
                    <Descriptions.Item span={24} key={'seat'} label={`${Booking.seat}:`}>{seat}</Descriptions.Item>
                    <Descriptions.Item span={24} key={'company'} label={`${Booking.company}:`}>{owner.company}</Descriptions.Item>
                    <Descriptions.Item span={24} key={'tel'} label={`${Booking.tel}:`}>{owner.tel}</Descriptions.Item>
                    <Descriptions.Item span={24} key={'price'} label={`${Booking.price}:`} className={'booking-price'}>
                        <Typography.Text strong>{currency.format(price)}</Typography.Text>
                        <Typography.Text style={{marginRight: 5}}>{Booking.toman}</Typography.Text>
                    </Descriptions.Item>
                </Descriptions>
                <Form form={form} name="booking" onFinish={onFinish}>
                    <Form.Item
                        name="travel"
                        initialValue={id}
                        style={{display:'none'}}
                        >
                        <Input type={'hidden'} />
                    </Form.Item>
                    {
                        person && (
                            <Form.Item
                                name="personCount"
                                className={'booking-person-count'}
                                initialValue={personCount}
                            >
                                <InputNumber
                                    size="large"
                                    type={'tel'}
                                    style={{width: '100%'}}
                                    min={1}
                                    max={capacity}
                                    onChange={(personCount) => setPersonCount(personCount)}
                                    addonAfter={<Typography.Text type="danger">{`${capacity} ${Booking.capacity}`}</Typography.Text>}
                                    addonBefore={
                                    <Space.Compact block>
                                        <Button type="link" icon={<TiArrowSortedUp size={22}/>} onClick={() => plusPersonCount(capacity)} />
                                        <Button type="link" icon={<TiArrowSortedDown size={22}/>} onClick={() => minusPersonCount()} />
                                    </Space.Compact>
                                }
                                />
                            </Form.Item>
                        )
                    }
                    <Form.Item
                        name="travelType"
                        className={'filter-radio'}
                        initialValue={travelType}
                    >
                        <Radio.Group size="large" buttonStyle="solid" onChange={({ target: { value: travelType }}) => {
                            settTravelType(travelType)
                            setPerson(travelType === TravelType.Person)
                            setClose(travelType === TravelType.Close)
                        }}>
                            <Radio.Button value={TravelType.Person} disabled={!personPrice}>{EnumLanguage.TravelType[TravelType.Person]}</Radio.Button>
                            <Radio.Button value={TravelType.Close} disabled={!closePrice || Boolean(travelBookingType)}>{EnumLanguage.TravelType[TravelType.Close]}</Radio.Button>
                            <Radio.Button value={TravelType.Home} disabled={!homePrice || Boolean(travelBookingType)}>{EnumLanguage.TravelType[TravelType.Home]}</Radio.Button>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item
                        name="payment"
                        className={'payment-radio'}
                        initialValue={payments[Math.floor(Math.random()*payments.length)]}
                    >
                        <Radio.Group>
                            <Radio disabled={!payments.includes(Payment.Zarinpal)} value={Payment.Zarinpal}><img alt={EnumLanguage.Payment[Payment.Zarinpal]} src={require('../../resources/media/logo-resize/zarinpal.png')} /></Radio>
                            <Radio disabled={!payments.includes(Payment.Sep)} value={Payment.Sep}><img alt={EnumLanguage.Payment[Payment.Sep]} src={require('../../resources/media/logo-resize/sep.png')} /></Radio>
                            <Radio disabled={!payments.includes(Payment.Pep)} value={Payment.Pep}><img alt={EnumLanguage.Payment[Payment.Pep]} src={require('../../resources/media/logo-resize/pep.png')} /></Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item shouldUpdate>
                        {() => (
                            <Button
                                type="primary"
                                block
                                htmlType="submit"
                                loading={loading}
                                disabled={
                                !form.getFieldValue('travel') ||
                                !form.getFieldValue('travelType') ||
                                (person && !form.getFieldValue('personCount')) ||
                                !form.getFieldValue('payment') ||
                                !policy ||
                                !!form.getFieldsError().filter(({ errors }) => errors.length).length}
                            >
                                { Booking.payment }
                            </Button>
                        )}
                    </Form.Item>
                    <Form.Item
                        name="policy"
                    >
                        <Checkbox checked={policy} onChange={({ target: { checked: policy } }) => setPolicy(policy)}><u>{Booking.Policy.title}</u></Checkbox>
                    </Form.Item>
                </Form>
                {
                    policy && (
                        <Timeline
                            className={'policy-timeline'}
                            items={[
                                {
                                    dot: <FaCheck />,
                                    children: Booking.Policy.one,
                                },
                                {
                                    dot: <FaCheck />,
                                    children: Booking.Policy.two,
                                },
                                {
                                    dot: <FaCheck />,
                                    children: Booking.Policy.three,
                                },
                                {
                                    dot: <FaCheck />,
                                    children: Booking.Policy.four,
                                },
                                {
                                    dot: <FaCheck />,
                                    children: Booking.Policy.five,
                                },
                                {
                                    dot: <FaCheck />,
                                    children: Booking.Policy.six,
                                },
                            ]}
                        />
                    )
                }
            </Space>
        )
    } else return <></>
}
